import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightModule } from '../insight/insight.module';
import { CmpsLazyRouterModule } from '../route.module';
import { CmpsUserModule } from '../user/user.module';

import { GridHumanInsightComponent } from './grid.hi.component';
import { HumanInsightComponent } from './human-insight.component';
import { TranslationIdMap } from './human-insight.i18n';
import { SuperGroupHumanInsightComponent } from './super-group.hi.component';
import { TrendHumanInsightComponent } from './trend.hi.component';
import { VisualHumanInsightComponent } from './visual.hi.component';
import { WizardHumanInsightComponent } from './wizard.hi.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbTooltipModule,
        NgChartModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule.forChild([]),
        CmpsUserModule,
        CmpsInsightModule,
        CmpsIconModule,
    ],
    declarations: [
        WizardHumanInsightComponent,
        SuperGroupHumanInsightComponent,
        VisualHumanInsightComponent,
        GridHumanInsightComponent,
        TrendHumanInsightComponent,
        HumanInsightComponent,
    ],
    exports: [HumanInsightComponent, WizardHumanInsightComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        // NO_ERRORS_SCHEMA
    ],
})
export class CmpsHumanInsightModule {}
